import { UniformCtaWithPolygonBackground } from "../src/cta-with-polygon-background-section.tsx";
export type { CtaWithPolygonBackgroundProps } from "../../../../../src/patterns/adg4/cta-with-polygon-background/cta-with-polygon-background.tsx";

export default UniformCtaWithPolygonBackground;
